import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

function customSwiper() {
  console.log('Attempting to initialize customSwiper');

  const testimonials = document.querySelector('.swiper.testimonials');

  if (testimonials) {
    // console.log('Element .swiper.testimonials found. Initializing Swiper...');
    const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const spaceBetweenRem = 3 * remInPx;
    const swiperTestimonials = new Swiper(testimonials, {
      modules: [ Autoplay, Navigation, Pagination],
      spaceBetween: spaceBetweenRem,
      // centeredSlides: true,
      loop: true,
      autoplay: {
        delay: 4500,
        disableOnInteraction: false
      },
      speed: 750,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        640: { slidesPerView: 1 },
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }
    });
    // console.log('Swiper for testimonials initialized:', swiperTestimonials);
  } else {
    console.warn('.swiper.testimonials element NOT FOUND in the DOM when customSwiper executed.');
  }

}

export default customSwiper
